import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function ContactInfo() {
  return <section className="py-16 bg-tcp-nearblack border-t border-white/5 px-4 sm:px-6 lg:px-8" data-id="element-10">
      <div className="max-w-7xl mx-auto" data-id="element-11">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-12">
          <div className="flex flex-col items-center text-center p-6 bg-tcp-black rounded-sm border border-white/5" data-id="element-13">
            <MapPinIcon className="w-8 h-8 text-tcp-red mb-4" data-id="element-14" />
            <h4 className="text-white font-medium mb-2" data-id="element-15">
              Corporate Headquarters
            </h4>
            <p className="text-tcp-gray text-sm" data-id="element-16">
              9820 NW 77th Ave. Hialeah Gardens, FL 33016
            </p>
          </div>

          <div className="flex flex-col items-center text-center p-6 bg-tcp-black rounded-sm border border-white/5" data-id="element-17">
            <PhoneIcon className="w-8 h-8 text-tcp-red mb-4" data-id="element-18" />
            <h4 className="text-white font-medium mb-2" data-id="element-19">Commercial Sales</h4>
            <p className="text-tcp-gray text-sm mb-1" data-id="element-20">
              Toll Free: (877) 367-2474
            </p>
            <p className="text-tcp-gray text-sm" data-id="element-21">Local: (305) 558-5352</p>
          </div>

          <div className="flex flex-col items-center text-center p-6 bg-tcp-black rounded-sm border border-white/5" data-id="element-22">
            <MailIcon className="w-8 h-8 text-tcp-red mb-4" data-id="element-23" />
            <h4 className="text-white font-medium mb-2" data-id="element-24">Email Us</h4>
            <p className="text-tcp-gray text-sm mb-1" data-id="element-25">
              Commercial@thechristmaspalace.com
            </p>
            <p className="text-tcp-gray text-sm" data-id="element-26"></p>
          </div>
        </div>
      </div>
    </section>;
}